export const PRICING_SECTION = {
  id: "group-access",
  title: "Групповой доступ для бизнеса",
  subtitle: "Подписка по числу сотрудников. Одна ссылка на всю команду в Telegram или MAX.",
  plans: [
    {
      packageId: "biz_s_15",
      title: "Микрокоманда",
      price: 4990,
      pricePeriod: "/ мес",
      badge: "Групповой доступ",
      perUnit: "До 15 сотрудников",
      segmentLabel: "1–15 чел.",
      features: [
        "30 дней подписки",
        "Ссылка для всей команды",
        "Онбординг и инструктаж",
      ],
      highlight: false,
    },
    {
      packageId: "biz_m_50",
      title: "Отдел",
      price: 9990,
      pricePeriod: "/ мес",
      badge: "Групповой доступ",
      perUnit: "16–50 сотрудников",
      segmentLabel: "16–50 чел.",
      features: [
        "30 дней подписки",
        "Несколько сценариев",
        "Обучение отдела",
      ],
      highlight: true,
    },
    {
      packageId: "biz_l_100",
      title: "Компания",
      price: 14990,
      pricePeriod: "/ мес",
      badge: "Групповой доступ",
      perUnit: "51–100 сотрудников",
      segmentLabel: "51–100 чел.",
      features: [
        "30 дней подписки",
        "Программы по подразделениям",
        "Для HR и L&D",
      ],
      highlight: false,
    },
  ],
};

export const PRICING_FAQ = [
  {
    question: "Как сотрудники получают доступ?",
    answer:
      "Вы оформляете подписку по размеру команды, публикуете сценарий и делитесь ссылкой в Telegram или MAX. Сотрудники переходят по ссылке и проходят программу без персональных ключей.",
  },
  {
    question: "Сколько сотрудников может пройти сценарий?",
    answer:
      "Лимит зависит от тарифа: до 15, до 50 или до 100 человек.",
  },
  {
    question: "Можно ли запустить обучение без подписки?",
    answer:
      "Редактор доступен для подготовки сценария. Для публикации и группового доступа по ссылке нужна активная бизнес-подписка.",
  },
  {
    question: "Как продлевается подписка?",
    answer:
      "Автоматического списания с карты нет. За 5 дней и за 1 день до окончания периода мы напомним по email — продлите подписку в разделе «Тарифы». Если оплата не поступит вовремя, групповой доступ к сценариям будет приостановлен.",
  },
];
